import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=fdf77660&scoped=true&"
import script from "./ItemsTable.vue?vue&type=script&lang=js&"
export * from "./ItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTable.vue?vue&type=style&index=0&id=fdf77660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf77660",
  null
  
)

export default component.exports